import editable from './editable'
import nfl from './nfl'

export default {
  currentTab: '',
  currentSubTab: null,
  widgetToUpdate: '',
  authStateChecked: false,
  userId: null,
  idToken: null,
  currentDash: '',
  dashOwner: '',
  dashboardSheets: [],
  $sheets: {},
  isUserAnonymous: false,
  caslRules: [],
  processes: {},
  errors: [],
  globalCustomJs: '',
  scopedCustomJs: '',
  dashboardNotRendered: false,
  settings: {},
  files: {},
  comments: {},
  pivotGridOptions: {},
  dgEditRowModalsShown: {},
  dgAddControlInProcess: {},
  chartComponentsSettingsShown: {},
  computedProps: {},
  userList: [],
  userListAll: [],
  customComponents: {},
  workflows: {},
  currentTemplate: null,
  customCode: null,
  // models
  fbUserModels: {},
  models_dashboardModel: {},
  fbWorkspaceModels: {},
  // additional
  ...editable,
  ...nfl
}
